export const GET_PLUGINS_REQUEST = 'GET_PLUGINS_REQUEST';
export const GET_PLUGINS_FAILURE = 'GET_PLUGINS_FAILURE';
export const GET_PLUGINS_SUCCESS = 'GET_PLUGINS_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/plugin/mutation-types.js